import { render } from "./twitter-button.vue?vue&type=template&id=4a426007"
import script from "./twitter-button.vue?vue&type=script&lang=js"
export * from "./twitter-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__